import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { reels } from '../data/reels';
import { ReelPlayer } from './ReelPlayer';
const mainPortrait = 'https://cdn.magicpatterns.com/uploads/oXBssEmeSELx1RuUfyydXw/IMG_2616.jpg';
const supportingPortrait = 'https://cdn.magicpatterns.com/uploads/eiKEjXWK1GWMt6ecDNqVjk/Leonardo_Headshots3771.jpg';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="bg-charcoal px-5 py-24 text-ivory md:px-8 md:py-32 lg:px-12" data-id="element-10" data-mp="22lp397og2unr">
      <div className="mx-auto max-w-[1440px]" data-id="element-11" data-mp="1xmlxtm4jymf9">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-12" data-mp="1xndu6z5z4o6l">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid grid-cols-2 gap-4" data-id="element-13" data-mp="1soan796fo7vz">
            <img src={mainPortrait} alt={t.about.portraitAlt} loading="lazy" className="col-span-2 h-[440px] w-full object-cover md:h-[600px]" data-id="element-14" data-mp="1jncs5gdz3apj" />
            <img src={supportingPortrait} alt={t.about.fullAlt} loading="lazy" className="col-span-2 h-64 w-full object-cover object-[center_28%] md:col-span-1 md:h-72" data-id="element-15" data-mp="xisxyp28j758" />
            <div className="hidden items-end border border-ivory/15 p-6 text-xs uppercase leading-6 tracking-widest2 text-ivory/50 md:flex md:h-72" data-id="element-16" data-mp="ivpxc9im8ido">
              {t.about.role.split(' · ').map(role => <React.Fragment key={role} data-id="element-17" data-mp="1bjdgrl85h2yq">{role}<br data-id="element-18" data-mp="1ghnbjupyq1jt" /></React.Fragment>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:pt-10" data-id="element-19" data-mp="1gfknvhca8ki9">
            <p className="text-xs font-semibold uppercase tracking-widest2 text-gold" data-id="element-20" data-mp="16lc016y75fqf">{t.about.kicker}</p>
            <h2 className="mt-5 font-display text-5xl leading-[0.95] md:text-7xl" data-id="element-21" data-mp="3r9qapj1jlrrh">{t.about.headline}</h2>
            <p className="mt-5 text-xs font-semibold uppercase tracking-widest2 text-ivory/55" data-id="element-22" data-mp="1xqpy2te9enf8">{t.about.role}</p>
            <div className="mt-8 max-w-2xl space-y-5 text-[15px] leading-relaxed text-ivory/68 md:text-base" data-id="element-23" data-mp="1srd1hgxl61zg">
              <p className="font-display text-xl leading-relaxed text-ivory/85 md:text-2xl" data-id="element-24" data-mp="1o0egw55kehqe">{t.about.intro}</p>
              {t.about.paragraphs.map(paragraph => <p key={paragraph} data-id="element-25" data-mp="1j00jri5i4s75">{paragraph}</p>)}
            </div>
            <blockquote className="mt-8 border-l border-gold/70 pl-5 font-display text-xl italic leading-relaxed text-gold-soft md:text-2xl" data-id="element-26" data-mp="1f19iqzxx0qer">{t.about.quote}</blockquote>
            <p className="mt-7 text-xs font-semibold uppercase tracking-widest2 text-ivory/50" data-id="element-27" data-mp="151sgytlsawo2">{t.about.cities}</p>

            <div className="mt-10 flex flex-wrap gap-x-3 gap-y-2 border-y border-ivory/15 py-5" data-id="element-28" data-mp="104ahdttnptsq">
              {t.about.credibility.map((item, index) => <React.Fragment key={item} data-id="element-29" data-mp="2uh8oy5nz2ccd" data-mpi={index}>
                  <span className="text-[10px] font-semibold uppercase tracking-[0.15em] text-ivory/55" data-id="element-30" data-mp="2uibfgchducrr">{item}</span>
                  {index < t.about.credibility.length - 1 ? <span aria-hidden="true" className="text-gold/55" data-id="element-31" data-mp="36zuiuczvn60u">·</span> : null}
                </React.Fragment>)}
            </div>
            <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2" data-id="element-32" data-mp="3brvqtmq0ial2">
              {t.about.highlights.map(item => <span key={item} className="text-xs text-ivory/45" data-id="element-33" data-mp="3gocius0c193f">{item}</span>)}
            </div>
          </motion.div>
        </div>

        <div className="mt-24 md:mt-32" data-id="element-34" data-mp="2k1rabz5di7p4">
          <div className="max-w-2xl" data-id="element-35" data-mp="2o08a1xmgsfwi">
            <p className="text-xs font-semibold uppercase tracking-widest2 text-gold" data-id="element-36" data-mp="2o19v8ux72iry">{t.about.work}</p>
            <h3 className="mt-5 font-display text-4xl leading-tight md:text-6xl" data-id="element-37" data-mp="2t25z58hjq4xd">{t.about.reels}</h3>
          </div>
          <div className="mt-12 max-w-5xl" data-id="element-38" data-mp="2xwtgmne4tz2g">
            {reels.map(reel => <ReelPlayer key={reel.id} reel={reel} featured data-id="element-39" data-mp="89c7xat84h2x" />)}
          </div>
        </div>
      </div>
    </section>;
}